var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomLivingRoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 52,
    viewBox: "0 0 93 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_8604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8799 25.21H40.3699C40.9199 25.21 41.3699 25.66 41.3699 26.21V51.65H29.8799V26.21C29.8799 25.66 30.3299 25.21 30.8799 25.21Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.46 25.21H90.95C91.5 25.21 91.95 25.66 91.95 26.21V51.65H80.46V26.21C80.46 25.66 80.91 25.21 81.46 25.21Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6299 51.6499H86.2099",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 37.8698C45.6299 35.4298 52.8299 33.8198 60.9899 33.8198C69.0699 33.8198 76.1999 35.3898 80.4599 37.7898",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6299 25.2102C41.1299 17.8302 50.4399 12.9702 61.0099 12.9702C71.4599 12.9702 80.6899 17.7202 86.2099 24.9702",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2899 14.88H0.919922L3.78992 0.75H21.4199L24.2899 14.88Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6101 14.8799V52.4599",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_8604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.7,
    height: 52.46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomLivingRoom);
export default __webpack_public_path__ + "static/media/roomLivingRoom.870df6c936598c67ddaa5fbdbd47cc90.svg";
export { ForwardRef as ReactComponent };